(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6890],{

/***/ 596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ terms; }
});

// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(31353);
// EXTERNAL MODULE: ./components/Texts/TextsPage.tsx
var TextsPage = __webpack_require__(36473);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Texts/TermsPage.tsx



var TermsPage = function TermsPage(_ref) {
  var data = _ref.data,
      setRefList = _ref.setRefList;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextsPage/* default */.Z, {
    title: data === null || data === void 0 ? void 0 : data.title,
    text: data === null || data === void 0 ? void 0 : data.body,
    setRefList: setRefList
  });
};

/* harmony default export */ var Texts_TermsPage = (TermsPage);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/pages/terms.tsx







var Terms = function Terms(_ref) {
  var data = _ref.data,
      seo = _ref.seo;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _useState = (0,react.useState)([]),
      refList = _useState[0],
      setRefList = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
      data: seo
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Texts_TermsPage, {
      data: data,
      setRefList: setRefList
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ var terms = (Terms);

/***/ }),

/***/ 22871:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms",
      function () {
        return __webpack_require__(596);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9415,9774,2888,179], function() { return __webpack_exec__(22871); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);